var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"title"}},[_c('div',{staticClass:"title-gradient"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"title-square"}),_c('div',{staticClass:"title-line"})]),_c('div',{staticClass:"title-border"})])}
var staticRenderFns = []

export { render, staticRenderFns }